import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";

// Thunk for getting Add Offered_Product
export const getEyeq = createAsyncThunk(
  "/website/bapat-eyeq/eyeqs",
  async (_, { rejectWithValue }) => {
    try {
      const eyeqData = await GET(API.GET_Bapat_Eyeq);
      return eyeqData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Create the slice
const Slice = createSlice({
  name: "eyeq",
  initialState: {
    content: "",
    eyeqs: [],
    error: null,
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(getEyeq.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getEyeq.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.eyeqs = action.payload?.data || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getEyeq.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      });
  },
});

export default Slice.reducer;
